import { ErrorMessage, Field, Formik } from "formik";
import React, { useState } from "react";
import { Alert, Button, Col, Form, Modal, Row, Stack } from "react-bootstrap";
import { useParams } from "react-router-dom";
import * as Yup from "yup";
import { documentService } from "../../../../services";
import { LoadingSpinner } from "../../../common/Loading/LoadingSpinner";
import { showToastSuccess, showToastError } from "../../../../utils";

type Props = {
    show: boolean;
    onClose: (added: boolean) => void;
    parentFolderId?: string;
};

const AddFolder: React.FC<Props> = ({ show, onClose, parentFolderId }) => {
    const [alertVariant, setAlertVariant] = useState("danger");

    const handleClose = () => onClose(false);
    const params = useParams();
    const taskId = params.id;
    return (
        <>
            <Modal centered show={show} keyboard={false} onHide={handleClose}>
                <Formik
                    initialValues={{
                        name: "",
                    }}
                    validationSchema={Yup.object().shape({
                        name: Yup.string().required("Folder name is required"),
                    })}
                    onSubmit={(values, { setStatus, setSubmitting, setFieldError }) => {
                        setStatus();
                        documentService.createFolder(parentFolderId, values.name,taskId as string).then(
                            (response: any) => {
                                setSubmitting(false);
                                if (response.status !== "Failure") {
                                    showToastSuccess("Folder added successfully!");
                                    setTimeout(() => onClose(true), 1000);
                                } else {
                                    setAlertVariant("danger");
                                    showToastError(response.message);
                                }
                            },
                            (error: any) => {
                                setAlertVariant("danger");
                                if (error.status === 400 && error.errors) {
                                    Object.keys(error.errors).forEach((key) => {
                                        const messages = error.errors[key];
                                        if (Array.isArray(messages)) {
                                            messages.forEach((message) => showToastError(message));
                                        }
                                    });
                                } else {
                                    showToastError("Something went wrong. Please try again.");
                                }
                                setSubmitting(false);
                            }
                        );
                    }}
                >
                    {({ errors, status, touched, isSubmitting, handleSubmit }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Modal.Header closeButton>
                                <Modal.Title>Add Folder</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Stack gap={3}>
                                    <Form.Group as={Row} className="mb-3" controlId="costInput">
                                        <Form.Label column sm={3}>
                                            Folder Name <span style={{ color: 'red' }}>*</span>
                                        </Form.Label>
                                        <Col sm={9}>
                                            <Field name="name" type="text" autoFocus className={"form-control" + (errors.name && touched.name ? " is-invalid" : "")} />
                                            <ErrorMessage name="name" component="div" className="invalid-feedback" />
                                        </Col>
                                    </Form.Group>
                                    {status && (
                                        <Alert variant={alertVariant} className="mt-3">
                                            {status}
                                        </Alert>
                                    )}
                                </Stack>
                            </Modal.Body>
                            <Modal.Footer>
                                <div className="form-group">
                                    <Button variant="primary" disabled={isSubmitting} type="submit" className="me-2">
                                        {isSubmitting ? <LoadingSpinner text="Adding..." /> : "Add Folder"}
                                    </Button>
                                    <Button variant="secondary" onClick={handleClose}>
                                        Cancel
                                    </Button>
                                </div>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>
        </>
    );
};

export { AddFolder };
